import React from "react";
import { Link } from "react-router-dom";
import discord from "@fyendalscollection/marketing/assets/discord.svg";
import styles from "@fyendalscollection/marketing/lib/components/DiscordInvite.module.scss";

export const DiscordInvite = (): JSX.Element => {
	return (
		<div className={styles.discord}>
			<Link to="https://discord.gg/RDYn8yDnFm" target="_blank" rel="noopener noreferrer">
				<div>
					<img src={discord} />
					<div>
						<div className={styles.subtitle}>Looking to contact us?</div>
						<div>From bug reports to feature ideas, we want to hear from you! Join the Fyendal&apos;s Collection community on Discord!</div>
					</div>
				</div>
			</Link>
		</div>
	);
};
